// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__A7TOL","input":"styles_input__3QGtz"};